/**
 * 表单的公用逻辑
 */
export default {
    data() {
        const emptyFunc = (rule, value, callback) => {
            let val = String(value)
            //数组中空对象或对象中值为空
            if (value instanceof Array) {
                val = ''
                for (let i = 0, len = value.length; i < len; i++) {
                    // 对象类型
                    if (value[i] instanceof Object) {
                        for (let k in value[i]) {
                            if (value[i][k].length > 0) {
                                val = value[i][k]
                                break;
                            }
                        }
                        if (val.length > 0) {
                            break
                        }
                    } else if (value[i] && String(value[i]).length > 0) {
                        val = String(value[i])
                        break;
                    }
                }
            }
            if (val.length > 0) {
                callback()
            } else {
                callback(new Error('不能为空'))
            }
        }   
        // 手机号码验证规则
        const validateMobile = (rule, value, callback) => {
            let reg = /^1[0-9]{10}$/ // 手机号正则表达式
            if (value === '') {
                callback(new Error('请输入手机号码'))
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号码'))
            } else {
                callback()
            }
        }
        // 工商注册号的验证规则
        const validateregistrationNumber = (rule, value, callback) => {
            let reg = /^\d{18}$/
            if (value ==='') {
                callback(new Error('请输入工商注册号'))
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的工商注册号'))
            } else {
                callback()
            }
        }
        // 工商注册名称验证规则
        const validateRegistrationBusiness = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入工商注册名称'))
            } else if (value.indexOf('工商') === -1) {
                callback(new Error('请输入正确的工商注册名称'))
            } else {
                callback()
            }
        }
        // 身份证号码的验证规则
        const validateIdCard = (rule, value, callback) => {
            let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
            if (value === '') {
                callback(new Error('请输入身份证号码'))
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的身份证号码'))
            } else {
                callback()
            }
        }
        // 密码验证规则
        const validatePass = (rule, value, callback) => {
            let regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im
            let regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im
            let reglen = /^.{6,}$/
            let regChinese = /[\u4e00-\u9fa5]/
            if (value === '') {
                callback(new Error('请输入密码'))
            } else if (regChinese.test(value)) {
                callback(new Error('密码不能含有中文'))
            } else if (regEn.test(value) || regCn.test(value)) { // 验证特殊字符
                callback(new Error('密码不能含有特殊字符'))
            } else if (!reglen.test(value)) {
                callback(new Error('密码长度最少六位'))
            } else if (this.bindForm.password_ag !== '') { // 匹配第二个密码框
                // this.$refs.lyForm.validateField('password_ag')
                callback()
            } else {
                callback()
            }
        }
        // 第二次密码验证规则
        const validatePassCheck = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.bindForm.password) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        // 特殊字符的验证
        const validateSpecial = (rule, value, callback) => {
            let regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im
            let regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im
            if (value === '') {
                callback(new Error('请输入登录名'))
            } else if (regEn.test(value) || regCn.test(value)) {
                callback(new Error('登录名不能含有特殊字符'))
            } else {
                callback()
            }
        }
        // 网址验证规则
        const validateUrl = (rule, value, callback) => {
            let str = '^((https|http|ftp|rtsp|mms)?://)'
                    + '?(([0-9a-z_!~*\'().&=+$%-]+: )?[0-9a-z_!~*\'().&=+$%-]+@)?' //ftp的user@ 
                    + '(([0-9]{1,3}.){3}[0-9]{1,3}' // IP形式的URL- 199.194.52.184 
                    + '|' // 允许IP和DOMAIN（域名） 
                    + '([0-9a-z_!~*\'()-]+.)*' // 域名- www. 
                    + '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].' // 二级域名 
                    + '[a-z]{2,6})' // first level domain- .com or .museum 
                    + '(:[0-9]{1,4})?' // 端口- :80 
                    + '((/?)|' // a slash isn't required if there is no file name 
                    + '(/[0-9a-z_!~*\'().;?:@&=+$,%#-]+)+/?)$'
            let reg = new RegExp(str)
            let chinastr = '^[\u4e00-\u9fa5]+$'
            let chinareg = new RegExp(chinastr)
            if (value === '') {
                callback(new Error('请输入网址'))
            } else if (!reg.test(value) || chinareg.test(value)) {
                callback(new Error('请输入正确的网站'))
            } else {
                callback()
            }
        }
        // 字母数字验证
        const validateLetnum =(rule, value, callback) => {
            let regletnum = /^[0-9a-zA-Z]*$/g
            if (value === '') {
                callback(new Error('请输入登录账号名'))
            } else if (!regletnum.test(value)) {
                callback(new Error('登录账号名只能由数字和字母组成！'))
            } else {
                callback()
            }
        }
        return {
            bindForm: {}, // 组件绑定的字段
            // 表单内置验证规则
            ruleValidate: {
                /**
                 * iview自带的验证规则
                 */
                empty: { validator: emptyFunc,required: true, message: '不能为空', trigger: 'blur' },  // 不能为空
                choose:  { required: true, message: '请选择', trigger: 'change' }, // 请选择
                multiSelect: { required: true, type: 'array', min: 1, message: '至少选择一个', trigger: 'change' }, // 多选 至少选一个
                multiSelectFive: { required: true, type: 'array', min: 5, message: '至少添加5个', trigger: 'change' }, // 多选 至少选5个
                multiSelectSix: { required: true, type: 'array', min: 6, message: '至少添加6个', trigger: 'change' }, // 多选 至少选6个
                multiSelectSec: { type: 'array', max: 2, message: '最多选择两个', trigger: 'change' }, // 最多选择两个
                multiSelectThr: { type: 'array', max: 3, message: '最多选择三个', trigger: 'change' }, // 最多选择三个
                multiSelectMax: { type: 'array', max: 100, message: '最多添加100个', trigger: 'change' }, // 最多添加100个
                chooseDate: { required: true, type: 'date', message: '请选择日期', trigger: 'change' },  // 选择日期
                mail: { type: 'email', message: '邮箱格式不正确', trigger: 'blur' },  // 邮箱
                /**
                * 自定义验证规则
                */
                mobile: { validator: validateMobile, trigger: 'blur' }, // 手机号码
                registrationNumber: { validator: validateregistrationNumber, trigger: 'blur' }, // 工商注册号
                registrationBusiness: { validator: validateRegistrationBusiness, trigger: 'blur' }, // 工商注册名称验证是否含有工商二字
                idCard: { validator: validateIdCard, trigger: 'blur' }, // 身份证号码验证
                password: { validator: validatePass, trigger: 'blur' }, // 密码验证
                passwdCheck: { validator: validatePassCheck, trigger: 'blur' }, // 确认密码
                loginName: { validator: validateSpecial, trigger: 'blur' }, // 登录名、特殊字符
                url: { validator: validateUrl, trigger: 'blur' }, // 网址、网站
                letnum: { validator: validateLetnum, trigger: 'blur' } // 网址、网站
            }
        }
    },
    computed: {
        formRules () {
            let rules = {}
            // 遍历子组件，获得它们的验证规则配置
            this.attrs.children.forEach((el) => {
                if (el.rules && el.rules.length > 0) {
                    let r = []
                    el.rules.forEach((rule) => {
                        r.push(this.ruleValidate[rule])
                    })
                    rules[el.field] = r
                }
            })
            return rules
        },
        labelWidth () {
            let width = 130
            if (this.attrs && this.attrs.labelWidth) {
                width = parseInt(this.attrs.labelWidth)
            }
            return width
        }
    },
    methods: {
        /**
         * 初始化表单绑定的字段
         * @param obj 传递的数据
         */
        initForm(obj) {
            if (this.attrs.children) {
                this.$set(this, 'bindForm', {})
                this.attrs.children.forEach((el) => {
                    if (!this.bindForm.hasOwnProperty(el.field)) {
                        let value = obj[el.field] || el.default || ''
                        this.setFieldValue(el.field, value)
                    }
                })
            }
        },
        /**
         * 设置字段上的值
         * @param {[String]} field [字段名]
         * @param {[type]} value [值]
         */
        setFieldValue(field, value) {
            this.$set(this.bindForm, field, value)
        },
        /**
         * 进行表单的验证
         */
        doValidate (formName = 'lyForm') {
            let bool = false
            if (this.$refs[formName]) {
                this.$refs[formName].validate((valid) => {
                    bool = valid
                    if (!bool) {
                        this.$Message.error('请将信息填写完整!');
                    }
                })
            }
            return bool
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/form.mixin.js